export class BaseProductComponent {
  isPopulated = false;
  hasErrors = false;
  fundId: string;
  shareClassCode: string;
  label: Map<string, string>;
}
